import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import {DEVICE_TYPE, SCREEN_SIZE} from '../../utils/constants';
import EntityList from '../react-entity-list';

import controller from './controller';
import messages from './messages';

import './index.scss';

class RelatedArtists extends React.Component {
  static contextTypes = {
    queue: PropTypes.object,
    globalRegistry: PropTypes.object,
  };

  @ssr_wait
  init() {
    return this.loadPerformers(this.props);
  }

  loadPerformers = (props) => {
    const {loadPerformers} = this.props;
    if (this.needComponentRender(props)) {
      return loadPerformers(props);
    }
  };

  UNSAFE_componentWillMount() {
    const {performers} = this.props;
    /* istanbul ignore else */
    if (!performers || performers.length === 0) {
      this.init();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {geo} = this.props;
    const nextGeo = nextProps.geo || {};
    const currentGeo = geo || {};
    if (nextGeo.latitude !== currentGeo.latitude || nextGeo.longitude !== currentGeo.longitude) {
      this.loadPerformers(nextProps);
    }
  }

  componentWillUnmount() {
    const {resetPerformers} = this.props;
    resetPerformers();
  }

  needComponentRender = ({geo = {}, isConcert, isSport}) => {
    const {latitude, longitude} = geo;

    return (isConcert && latitude && longitude) || isSport;
  };

  getTitle = ({isConcert, isSport, groupings = [], intl}) => {
    const concertTitle = intl.formatMessage(messages.concertTitle);
    if (isConcert) {
      return concertTitle;
    } else if (isSport) {
      if (groupings.length > 0) {
        return intl.formatMessage(messages.sportTitle);
      }

      return concertTitle;
    }
  };

  render() {
    const {performers = [], total, deviceType} = this.props;
    let {screenSize} = this.props;
    let mwebCarouselProps = {};
    let perPage = 5;

    if (deviceType === DEVICE_TYPE.PHONE) {
      screenSize = SCREEN_SIZE.LARGE;
      perPage = 2;
      mwebCarouselProps = {
        carouselScrollMode: true,
      };
    } else if (screenSize === SCREEN_SIZE.MEDIUM) {
      perPage = 4;
    } else if (screenSize === SCREEN_SIZE.SMALL) {
      perPage = 3;
    }

    if (this.needComponentRender(this.props)) {
      const title = this.getTitle(this.props);

      return (
        <div className="RelatedArtist__Container">
          <EntityList
            type="performer"
            screenSize={screenSize}
            entityData={performers}
            title={title}
            noFetch
            totalCount={total}
            startPage={0}
            autoScaleMode
            forceCarousel
            perPage={perPage}
            {...mwebCarouselProps}
          />
        </div>
      );
    }

    return null;
  }
}

RelatedArtists.propTypes = {
  performers: PropTypes.array,
  total: PropTypes.number,
  deviceType: PropTypes.string,

  /** Screen size name */
  screenSize: PropTypes.oneOf(['small', 'medium', 'large']),

  /** The geo object containing the location information for the user */
  geo: PropTypes.object,
  resetPerformers: PropTypes.func.isRequired,
  loadPerformers: PropTypes.func.isRequired,
};

export {RelatedArtists};

export default injectIntl(connect(controller)(RelatedArtists));
